import { type IUserSlotService } from '@/app/types/settingsTypes'

import style from './Service.module.scss'

interface IProps extends IUserSlotService {}

export const Service = (props: IProps) => {
    const { cost, serviceCode, serviceName } = props
    return (
        <div className={style.container}>
            <div className={style.serviceTitle}>
                <span>Услуга:</span>
            </div>
            <div className={style.serviceData}>
                <span>{serviceName}</span>
                <span>{serviceCode}</span>
                <span>{cost}</span>
            </div>
        </div>
    )
}
